(function(){

  if(Shopify.CartType == "cart_page"){
    if( window.cart_gift != null && getGiftCookieExist("ignored_gift_popup") != "true" ){
      GiftProductToCart(null);
    }
  }

  document.addEventListener('ajaxProduct:added', function(e){
    //re-check the gift product after adding another products
    console.log("recheck gift product when another product is added to cart");
    gift_removed = "0";
    localStorage.setItem("gift_removed", "0");
    // document.cookie = 'removed_gift_manually=false;expires=0;path=/';
  });

  document.addEventListener('cart_gift:updated', function(evt){
    //re-check the gift product after updating the cart
    console.log("recheck gift product when another cart gift event is fired", getGiftCookieExist("ignored_gift_popup"));
    if( document.querySelector('[data-section-type="gift-popup"]') != null && window.gift_test != "true"){
      // let cart_page_subtotal = document.querySelector("[cart-subtotal]") ? parseInt(document.querySelector("[cart-subtotal]").getAttribute('cart-subtotal')) * 1.0 : 0;
      let cart_page_subtotal = document.querySelector("[data-subtotal]") ? parseInt(document.querySelector("[data-subtotal]").getAttribute('subtotal-amount')) * 100.0 : 0;
      let gift_threshold = window.cart_gift.threshold;
      gift_threshold = gift_threshold.replace(',', '.');
      gift_threshold = parseInt(gift_threshold) * 100.0;
      console.log(" reset gift attributes again:", cart_page_subtotal, gift_threshold);

      if(cart_page_subtotal < gift_threshold ){
        document.cookie = 'ignored_gift_popup=false;expires=0;path=/';
        getGiftCookieExist("removed_gift_manually") != "true" ? document.cookie = 'removed_gift_manually=false;expires=0;path=/' : null;
        window.enable_gift_popup = "true";
        window.ignored_gift_popup = undefined;
        console.log(" reset gift attributes again");
        document.cookie = 'removed_gift_manually=false;expires=0;path=/';
      }
    }
    if( window.cart_gift != null && getGiftCookieExist("ignored_gift_popup") != "true" && getGiftCookieExist("removed_gift_manually") != "true" ){
      console.log("recheck");
      GiftProductToCart(evt);
    }
  });

  function GiftProductToCart(e){
    var gift_removed = localStorage.getItem("gift_removed")? localStorage.getItem("gift_removed") : "0";

    var gift_variant_id = window.cart_gift.id,
        gift_threshold = window.cart_gift.threshold,
        cart_page_subtotal = document.querySelector("[cart-subtotal]") ? parseInt(document.querySelector("[cart-subtotal]").getAttribute('cart-subtotal')) * 1.0 : 0,
        cart_subtotal = e ? e.detail.total * 1.0 : cart_page_subtotal;

    gift_threshold = gift_threshold.replace(',', '.');
    gift_threshold = parseInt(gift_threshold) * 100.0;

    var cart_gift_product = document.querySelector('[data-cart-gift-exist]');

    if(cart_gift_product){
      // IF the cart has the cart_gift_product
      if(cart_subtotal < gift_threshold ){
        //IF THE SUBTOTAL IS LESS THAN THE THRESHOLD ->  GIFT PRODUCT SHOULD BE REMOVED
        removeCartGiftProduct(gift_variant_id);
      }else{
        // Adjust the remove button of the gift product
        var remove_btn = cart_gift_product.querySelector('.gift_cart__product-remove');
        remove_btn.addEventListener('click',function(){
          gift_removed = "1";
          removeCartGiftProduct(gift_variant_id);
          localStorage.setItem("gift_removed", "1");
        });
      }
    }else{
      // IF the cart doesn't have cart_gift_product
      console.log("IF the cart doesn't have cart_gift_product:",gift_removed );
      console.log("cart_subtotal:",cart_subtotal );
      console.log("gift_threshold:",gift_threshold );

      // if the subtotal exceeds the threshold value and the gift product hasn't added yet or removed from its btn
      if( (cart_subtotal >= gift_threshold) && (gift_removed == "0") ){
        // add gift product here
        gift_removed = "0";
        localStorage.setItem("gift_removed", "0");

        if(document.querySelector('[data-section-type="gift-popup"]') != null && window.enable_gift_popup == "true" && (window.enable_shaker_popup != "true" || getGiftCookieExist("ignored_shaker_popup") == "true") && window.gift_test != "true"){
          showCartGiftPopup();
        }
        else if(window.shaker_test == "true" && window.gift_test != "true" && window.gift_test != undefined ){
          showCartGiftPopup();
        }
        else{
          // if(window.ignored_gift_popup != "true" || document.querySelector('[data-section-type="gift-popup"]') == null){
            addCartGiftProduct(gift_variant_id);
          // }
        }
      }
    }
  }

  function getGiftCookieExist(name) {
    function escape(s) { return s.replace(/([.*+?\^$(){}|\[\]\/\\])/g, '\\$1'); }
    var match = document.cookie.match(RegExp('(?:^|;\\s*)' + escape(name) + '=([^;]*)'));
    return match ? match[1] : null;
  }

  function showCartGiftPopup(){
    console.log("showCartGiftPopup",window.enable_gift_popup);
    console.log("showCartGiftPopup",window.enable_gift_popup);

    if(window.ignored_gift_popup != "true" && document.querySelector('[data-section-type="gift-popup"]') != null ){
      let gift_popup = new theme.Modals('NewsletterPopup-gift_popup', 'newsletter-popup-modal');
      gift_popup.open();
      if(getGiftCookieExist("ignored_gift_popup") != "true"){
        window.show_popup = "true";
      }
    }else{
      window.show_popup = "false";
    }
  }
  // add product to cart
  function addCartGiftProduct(variant_id){
    console.log("addCartGiftProduct",window.enable_gift_popup);

    let formItems =[];
    formItems.push(
      {
        'id': variant_id,
        'quantity': 1
      }
    );
    let formData = {
      'items': formItems
    };
    fetch(theme.routes.cartAdd, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
      },
      body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(product => {
      if (product.status === 422){
        return;
      }
      if(Shopify.CartType == "cart_page"){
        document.dispatchEvent(new CustomEvent('cart:build'));
      }else{
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: {
            product: product
          }
        }));
      }
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }

  // add product to cart
  function removeCartGiftProduct(variant_id){

    fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
      },
      body: JSON.stringify({
          updates: {
            [variant_id]:0
          }
      })
    })
    .then(response => response.json())
    .then(function(response){
      document.dispatchEvent(new CustomEvent('cart:build'));
      window.ignored_gift_popup = "false";
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }

}());
